<template>
	<div class="flex flex_col lightpage">
		<!-- 上面的选择 -->
		<div class="selects">
			<el-form
				:model="queryParam"
				ref="ruleform"
				:inline="true"
				class="flex flex_ju_sb warnform-inline"
			>
				<div class="form-inputs">
					<el-form-item
						label="选择生产区域"
						style="margin-bottom: 0; margin-right: 10px"
						v-if="isShowAllSelect"
					>
						<el-select
							v-model="allOrgId"
							:placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
							@change="changeAllOrg"
						>
							<el-option
								v-for="(item, index) in orgAllSelect"
								:key="index"
								:value="item.orgId"
								:label="item.orgName"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="isShowAllSelect ? '' : '选择气象站'">
						<el-select
							:placeholder="orgSelect.length ? '请选择' : '暂无设备'"
							v-model="queryParam.deviceCode"
							@change="changeCode"
						>
							<el-option
								v-for="(item, index) in orgSelect"
								:key="index"
								:value="item.facId"
								:label="item.facName"
							></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="时间区间" class="form-picker">
						<div class="picker-divs">
							<el-date-picker
								v-model="queryParam.startTime"
								size="small"
								type="date"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions0"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
						</div>

						<span class="pick-word">至</span>
						<div class="picker-divs">
							<el-date-picker
								v-model="queryParam.endTime"
								size="small"
								type="date"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions1"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
						</div>
					</el-form-item>
				</div>
				<el-form-item class="form-btns">
					<el-button type="primary" @click="onSubmit">查询</el-button>
					<el-button type="primary" @click="exportDownLoad">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 下面的折线图 -->
		<div class="chart-all" v-loading="loading">
			<!-- 导出按钮 -->
			<!-- <div
				class="flex flex_a_c flex_ju_c btn-export"
				v-if="isShowLine"
				@click="exportDownLoad"
			>
				<img src="@/assets/image/analysis/icon_export.png" alt="" />导出
			</div> -->
			<!-- 图表 -->
			<div class="chart-div" ref="chartRef" v-show="isShowLine"></div>
			<div
				class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
				v-show="!isShowLine"
			>
				<img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
				<div class="table-emptyword">暂无数据</div>
			</div>
			<!-- 底部说明文字 -->
			<!--			<div class="font_16 chart-title">气象站每日光照强度平均值</div>-->
		</div>
	</div>
</template>

<script>
/**
 * @description 日光照分析
 */
import tableMinin from '@/mixins/TableMinin'
import { todayTime, monthStartDay } from '../../times/moment'
import {
	prevDayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from '../../times/moment'
export default {
	mixins: [tableMinin],
	data() {
		return {
			orgAllSelect: [], // 生产区域下拉选
			allOrgId: '', /// 分公司下面选中的orgid
			orgSelect: [],
			nowSBName: '',
			isMakeTime: false,
			isShowLine: false, // 是否显示折线图
			lineAllData: {}, // 折线图总数据
			url: {
				lineChart: '/napi/index/lightAnalyzeDay',
				// lineChart: "/napi/index/averageDailyIllumination",
			},
			pickerOptions0: {
				disabledDate: (time) => {
					if (this.queryParam.endTime) {
						if (this.queryParam.endTime != '') {
							let num = new Date(this.queryParam.endTime).getTime()
							return time.getTime() > num
						} else {
						}
					} else {
						return false
					}
				},
			},
			pickerOptions1: {
				disabledDate: (time) => {
					let num = new Date().getTime()
					if (time.getTime() > num) {
						return true
					} else {
						let startNum =
							new Date(this.queryParam.startTime).getTime() - 43200000
						if (time.getTime() < startNum) {
							return true
						} else {
							return false
						}
					}
				},
			},
		}
	},
	mounted() {
		this.$set(this.queryParam, 'startTime', monthStartDay())
		this.$set(this.queryParam, 'endTime', todayTime())
		// this.$set(this.queryParam, 'startTime', '2022-04-01')
		// this.$set(this.queryParam, 'endTime', '2022-04-20')

		// this.getOrgids()

		// 获取头部下拉选
		if (this.isShowAllSelect) {
			// 获取上面的生产区域信息
			this.getAllOrgids()
		} else {
			this.getOrgids()
		}
	},
	methods: {
		// 获取头部站点下拉选
		getOrgids(isFen = false, isReauestLine = true) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				orgId: '',
			}
			if (isFen) {
				params.orgId = this.allOrgId
			} else {
				params.orgId = userInfos.orgId
			}
			this.$http
				.getAction(this.$api.qxfindDeviceByOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						if (datas && datas.length) {
							// 获取页面上相关的其它数据
							if (isReauestLine) {
								this.$set(
									this.queryParam,
									'deviceCode',
									datas[0]['facId']
								)
								// 16079534
								this.nowSBName = datas[0]['facName']
								this.loading = true
								setTimeout(() => {
									/// 获取折线图数据
									this.getLineData()
								}, 300)
							} else {
								this.$set(this.queryParam, 'deviceCode', '')
								// 16079534
								this.nowSBName = ''
							}
						} else {
							if (isReauestLine) {
								this.isShowLine = false
							}
							this.loading = false
							this.$set(this.queryParam, 'deviceCode', '')
						}
					} else {
						this.orgSelect = []
						this.isShowLine = false
						this.loading = false
						this.$set(this.queryParam, 'deviceCode', '')
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.isShowLine = false
					this.loading = false
					this.$set(this.queryParam, 'deviceCode', '')
				})
		},
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.loading = false
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			this.allOrgId = val
			console.log(val)
			this.getOrgids(true, false)
		},
		// 查询按钮点击
		onSubmit() {
			this.$refs['ruleform'].validate((valid) => {
				if (valid) {
					if (!this.orgSelect.length) {
						return this.$message('暂无设备', 'warning')
					}
					if (!this.queryParam.deviceCode || this.queryParam.deviceCode == '') {
						return this.$message('请选择设备', 'warning')
					}
					let miao = this.queryParam.startTime.split(' ')[1] || '00:00:00'
					let preMonthDay = new Date(
						GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
							' ' +
							miao
					) //6个月之后的日期
					let startTimeCuo = new Date(this.queryParam.endTime).getTime()
					if (startTimeCuo >= preMonthDay.getTime()) {
						this.$message('选择时间跨度范围不允许超过6个月', 'warning')
						return false
					}
					let changeArr = this.orgSelect.filter((item) => {
						return item.facId == this.queryParam.deviceCode
					})
					this.nowSBName = changeArr[0]['facName']
					this.getLineData()
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		getLineData() {
			this.loading = true
			let params = Object.assign({}, this.queryParam)
			let xAxis = []
			let yAxis = []
			let yName = ''
			let yUnit = ''
			if (params.startTime) {
				params.startTime = `${params.startTime} 00:00:00`
			}
			if (params.endTime) {
				params.endTime = `${params.endTime} 23:59:59`
			}
			this.$http
				.postAction(this.url.lineChart, params)
				.then(
					(res) => {
						console.log(res)
						// TODO 数据待处理
						if (res.meta.success) {
							let datas = res.data || {}
							this.lineAllData = datas || {}
							if (datas && JSON.stringify(datas) != '{}') {
								this.makeData(datas)
								// if (!Object.keys(datas).length) {
								// 	this.isShowLine = false
								// 	return
								// }
								// Object.keys(datas).forEach((key) => {
								// 	xAxis.push(key)
								// 	yAxis.push(datas[key][0]['acquisitionData'])
								// })
								// if (xAxis.length) {
								// 	yName = datas[xAxis[0]][0]['acquisitionItemName']
								// 	yUnit = datas[xAxis[0]][0]['acquisitionItemUnitCode']
								// }
								// if (xAxis.length) {
								// 	this.isShowLine = true
								// 	this.$nextTick(() => {
								// 		this.makeChart(xAxis, yAxis, yName, yUnit)
								// 	})
								// } else {
								// 	this.isShowLine = false
								// }
							} else {
								this.lineAllData = {}
								this.isShowLine = false
							}
						} else {
							this.lineAllData = {}
							this.isShowLine = false
						}
					},
					(error) => {
						this.lineAllData = {}
						this.isShowLine = false
					}
				)
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		makeData(datas) {
			let allData = []
			let xAxis = []
			let yAxis = []
			let yUnit = ''
			if (!Object.keys(datas).length) {
				this.isShowLine = false
				return
			}
			Object.keys(datas).forEach((key, index) => {
				allData.push(datas[key])
				allData[index]['times'] = key
			})
			allData.sort(function (a, b) {
				let obj1 = a['times']
				let obj2 = b['times']
				const val1 = Math.floor(new Date(obj1).getTime() / 1000)
				const val2 = Math.floor(new Date(obj2).getTime() / 1000)
				return val1 - val2
			})
			allData.forEach((item) => {
				xAxis.push(item['times'])
				yAxis.push(item.avgValue)
			})
			if (xAxis.length) {
				yUnit = allData[0]['lightIntensityUnit']
			}
			if (xAxis.length) {
				this.isShowLine = true
				this.$nextTick(() => {
					this.makeChart(xAxis, yAxis, yUnit)
				})
			} else {
				this.isShowLine = false
			}
		},
		// 折线图绘制
		makeChart(xData, yData, yUnit) {
			const _this = this
			let myChart = this.$echarts.init(this.$refs.chartRef)
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [11, 17],
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						infos += `<div style="text-align:left;">${_this.nowSBName}</div><div style="margin:12px 0">${param[0].name}</div><div style="color:#2DAEA9">光照强度平均值：${param[0].value}Lux</div>`
						return infos
					},
					// formatter: '气象站一号</br>{b}</br>每日降雨量累计：{c}mm',
				},
				color: '#2DAEA9',
				grid: {
					left: '5%',
					bottom: '8%',
					top: '15%',
					right: '3%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					name: '（' + yUnit + '）',
					nameTextStyle: {
						color: '#6B6B6B',
						fontSize: 14,
						align: 'right',
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
				},
				series: [
					{
						type: 'line',
						smooth: true,
						showSymbol: false,
						symbolSize: 14,
						itemStyle: {
							borderColor: '#2DAEA9',
							borderWidth: 4,
						},
						data: yData,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		changeCode(val) {
			// let changeArr = this.orgSelect.filter((item) => {
			//   return item.facId == val;
			// });
			// this.nowSBName = changeArr[0]["facName"];
		},
		// 导出
		exportDownLoad() {
			if (!this.isShowLine) {
				this.$message('暂无导出数据', 'error')
				return
			}
			// let org = this.queryParam.deviceCode
			// let start = this.queryParam.startTime
			// let end = this.queryParam.endTime
			// let urls = '/sys/weaGzqdAvgDay/exportExcel'
			// let baseUrl = process.env.VUE_APP_API_BASE_URL
			// window.location.href = baseUrl + urls + '?org=' + org + '&start=' + start + '&end=' + end

			if (!this.lineAllData || JSON.stringify(this.lineAllData) == '{}') return
			// 对折线图总数据进行处理
			let arrList = []
			let itemPush = {}
			let lineAllData = JSON.parse(JSON.stringify(this.lineAllData))
			Object.keys(lineAllData).forEach((key) => {
				let item = lineAllData[key]
				itemPush = {
					times: key,
					names: `${item.lightIntensityName}${item.lightIntensityUnit}`,
					values: item.avgValue,
					codeName: this.nowSBName,
				}
				arrList.push(itemPush)
			})
			arrList.sort(function (a, b) {
				let obj1 = a['times']
				let obj2 = b['times']
				const val1 = Math.floor(new Date(obj1).getTime() / 1000)
				const val2 = Math.floor(new Date(obj2).getTime() / 1000)
				return val2 - val1
			})
			let fileList = arrList
			let fileHead = ['时间', '光照强度平均值(Lux)']
			let filterVal = ['times', 'values']
			this.$nextTick(() => {
				this.handleExportXls(
					fileList,
					fileHead,
					filterVal,
					this.nowSBName + '日光照分析'
				)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.lightpage {
	height: 100%;
}
// 下面的折线图
.chart-all {
	margin-top: 0.15rem;
	width: 20.07rem;
	flex: 1;
	min-height: 610px;
	background: #ffffff;
	border-radius: 0.19rem;
	position: relative;
	// 导出按钮
	.btn-export {
		width: 1.05rem;
		height: 0.45rem;
		color: #42b5b2;
		border: 1px solid #2daea9;
		border-radius: 4px;
		font-size: 0.17rem;
		position: absolute;
		top: 0.31rem;
		right: 0.39rem;
		cursor: pointer;
		z-index: 20;
		img {
			width: 0.25rem;
			margin-right: 0.09rem;
		}
	}
	.chart-div {
		width: 20.07rem;
		// height: 8.5rem;
		height: 100%;
	}
	.bottom-empty {
		height: 100%;
		width: 100%;
	}
	.chart-title {
		color: #333;
	}
}
</style>
